import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-x-twitter",
  "use": "icon-x-twitter-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-x-twitter\"><path d=\"M9.09789 6.97909L13.9548 1.33334H12.8039L8.58662 6.23547L5.21831 1.33334H1.33337L6.42691 8.74623L1.33337 14.6667H2.48437L6.93789 9.48985L10.4951 14.6667H14.38L9.09761 6.97909H9.09789ZM7.52145 8.81154L7.00537 8.07338L2.89909 2.19978H4.66695L7.98076 6.93996L8.49685 7.67812L12.8044 13.8396H11.0365L7.52145 8.81182V8.81154Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol